import { IDCheckCompleteIcon } from '../../../../components/svg/IDCheckCompleteIcon';
import { Button } from '../../../components/Button/Button';
import { Card } from '../../../components/Card/Card';
import { WhiteLabelOverride } from '../../../components/WhiteLabelOverride/WhiteLabelOverride';
import { useNavigateToNextRequirement } from '../../hooks/useNavigateToNextRequirement';

export const IDCheckComplete = () => {
  const { nextRequirementName, goToNextRequirement } =
    useNavigateToNextRequirement();

  return (
    <Card title="">
      <div className="flex flex-col justify-center">
        <h2 className="mb-s flex flex-col items-center justify-center text-l font-bold">
          <IDCheckCompleteIcon className="mb-xl" />
          ID Check complete
        </h2>
        <p className="mb-l text-center text-s font-reg">
          Everything looks good, you can now continue.
        </p>
        <WhiteLabelOverride componentType="button" disabled={false}>
          <Button
            className="w-full text-m font-bold"
            onClick={goToNextRequirement}
          >
            Continue to {nextRequirementName}
          </Button>
        </WhiteLabelOverride>
      </div>
    </Card>
  );
};
